import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import { generateAndShareBrowserPdf } from '../../assets/js/browserPdf.js';

import './Outstanding.scss';

class Outstanding extends Component{
  constructor(props){
    super(props);
    this.executiveSelect = React.createRef();
    this.duePeriodSelect = React.createRef();
    this.state = {
      executives : [],
      executive : "",
      customers : [],
      showing_customers : []
    }
    this.executiveChange = this.executiveChange.bind(this);
    this.formChange = this.formChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.getOutStandingData = this.getOutStandingData.bind(this);
    this.savePDF = this.savePDF.bind(this);
    this.b64toBlob = this.b64toBlob.bind(this);
    this.sharePDF = this.sharePDF.bind(this);


  }
  componentDidMount(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getOutstandingExecutive`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         executives : return_data.executives,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });

     var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/ageingReportByDuration`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        var dealers = return_data.dealers.filter( (item) => ( item.bills.length));
        dealers = dealers.sort(function(a,b){
          return a.no_due - b.no_due
        });
        obj_this.setState({
         customers : dealers,
         showing_customers : dealers,
         outstanding  : parseFloat(return_data.outstanding).toFixed(3),
         due_exceed : parseFloat(return_data.due_exceed).toFixed(3)
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
    $(".customer_outstanding_page_container").on("click",".pdf_dwnld",function(e){
      e.stopPropagation();
      const dealer_id = $(this).attr("dealer_id");
      const url1 = `${process.env.REACT_APP_SSS}/api/getOutstandingCustomerWise`;
        
      obj_this.context.loading(1);
      $.ajax({
        url : url1,
        data : {
          sid : obj_this.context.user_details.sid,
          dealer_id : dealer_id
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          var state_object = return_data.dealers;
          
          let options = {
            documentSize: 'A4',
            type: "share",
            fileName: state_object.name + '-Outstanding'+'.pdf'
          }

          var text = '<html><head><style>table, th, td {border: 1px solid; padding: 10px; text-align: center; font-size: 11px; margin:auto} td {white-space: nowrap;} table {width: 100%; border-collapse: collapse; margin: 0;} h4 {text-align: center;} .info {margin-bottom: 20px;} .info span {font-weight: bold;} </style></head><body><h4><b>' + state_object.division_name + '</b></h4><h4><u>OUTSTANDING</u></h4><div class="info"><span>Customer :</span>&nbsp;&nbsp;' + state_object.name + '</div><table><thead><tr><th>Sl No.</th><th>Date</th><th>Invoice No</th><th>Amount</th><th>Due Exceeded</th><th>Due Date</th><th>Receivables</th><th>PDC Amount</th><th>Final Balance</th></tr></thead><tbody>';

          var pdc_total = 0;
          var receivable_total = 0;
          for (var i = 0; i < state_object.bills.length; i++) {
            var cheque_amount_num = parseFloat(state_object.bills[i].cheque_amount);
            cheque_amount_num = cheque_amount_num > 0 ? cheque_amount_num : 0;
            var receivable_num = parseFloat(state_object.bills[i].receivable);
            receivable_num = receivable_num || 0;
            var final_balance_num = receivable_num - cheque_amount_num;
            pdc_total += cheque_amount_num;
            receivable_total += receivable_num;
            text += '<tr><td>' + [i + 1] + '</td>';
            text += '<td>' + state_object.bills[i].bill_date + '</td>';
            text += '<td>' + state_object.bills[i].bill_no + '</td>';
            text += '<td>' + state_object.bills[i].bill_amount + '</td>';
            text += '<td>' + state_object.bills[i].exceed + ' (' + state_object.bills[i].due_days + ' Days)</td>';
            text += '<td>' + state_object.bills[i].bill_due_date + '</td>';
            // text += '<td>' + (state_object.bills[i].cheque_date ? state_object.bills[i].cheque_date : '-') + '</td>';
            let chequeDateStr = '-';
            if (state_object.bills[i].cheque_date) {
              const d = new Date(state_object.bills[i].cheque_date);
              chequeDateStr = `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth()+1).toString().padStart(2, '0')}-${d.getFullYear()}`;
            }
            text += '<td>' + receivable_num.toFixed(3) + '</td>';
            text += '<td>' + (cheque_amount_num > 0 ? (cheque_amount_num.toFixed(3) + (state_object.bills[i].cheque_date ? ' (' + chequeDateStr + ')' : '')) : '-') + '</td>';
            text += '<td>' + final_balance_num.toFixed(3) + '</td></tr>';
          }

          var final_balance_total = (parseFloat(state_object.pending_total) || 0) - pdc_total;
          text += '</tbody><tfoot><tr><th colspan="4">Total&nbsp;&nbsp;: </th><th>'  + state_object.exceed_due_total +' ' + obj_this.context.currency + ' </th><th></th><th>' + receivable_total.toFixed(3) + ' ' + obj_this.context.currency + ' </th><th> ' + pdc_total.toFixed(3) + ' ' + obj_this.context.currency + ' </th><th> ' + final_balance_total.toFixed(3) + ' ' + obj_this.context.currency + ' </th></tr></tfoot></table></body></html>';

     
         
          if (typeof window !== 'undefined' && window.cordova && typeof pdf !== 'undefined') {
            pdf.fromData(text, options)
              .then((base64) => {
                obj_this.savePDF(base64, options.fileName);
              })
              .catch((err) => console.log(err));
          } else {
            generateAndShareBrowserPdf(text, options.fileName, () => {});
          }
          obj_this.context.loading(0);
        } else {
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function () {
        obj_this.context.loading(0);
        alert("Network error");
      });
    });
  }

  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  sharePDF(fileUrl, mimeType) {
    window.plugins.socialsharing.share(null, null, fileUrl, null, function (err) {
      console.error('Error sharing PDF:', err);
    }, {
      subject: 'Share PDF', // Subject for the sharing action
      mimeType: mimeType // Specify the MIME type of the file being shared
    });
  }

  savePDF(base64Data, fileName) {
    var blob = this.b64toBlob(base64Data, 'application/pdf');
    var blobUrl = URL.createObjectURL(blob);
    console.log('Documents Directory URL:', cordova.file.dataDirectory);
    var self = this; // Store a reference to 'this'

    document.addEventListener('deviceready', function () {
      window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (dirEntry) {
        dirEntry.getFile(fileName, { create: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function () {
              console.log("Successful file write:", fileName);
              // Read the file after writing (if needed)
              self.sharePDF(fileEntry.toURL(), 'application/pdf');
            };

            fileWriter.onerror = function (e) {
              console.log("Failed file write:", e.toString());
            };

            fileWriter.write(blob); // Write the Blob to the file
          }, function (err) {
            console.error('Error creating file writer:', err);
          });
        }, function (err) {
          console.error('Error getting file:', err);
        });
      }, function (err) {
        console.error('Error resolving file system URL:', err);
      });
    });
  }

  executiveChange(option){
    this.setState({
      executive : option
    });
  }  

  
  formChange(e){
    // console.log(e.target.value);
    var showing_customers =[];
    if(e.target.value){
      showing_customers = this.state.customers.filter((item) => {return item.name.toLowerCase().includes(e.target.value.toLowerCase())});
    }
    else{
      showing_customers = this.state.customers;
    }
    // showing_customers = showing_customers.length?showing_customers:this.state.customers;
    this.setState({
      showing_customers : showing_customers
    });
  }

  getOutStandingData(){

    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/ageingReportByDuration`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
        executive_id : obj_this.state.executive.value,
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      var dealers = return_data.dealers;
      dealers = dealers.sort(function(a,b){
        return a.no_due - b.no_due
      });
      // return;
      if(return_data.status == "success"){
        var dealers = return_data.dealers.filter( (item) => ( item.bills.length));
        obj_this.setState({
         customers : dealers,
         showing_customers : dealers,
         outstanding  : parseFloat(return_data.outstanding).toFixed(3),
         due_exceed : parseFloat(return_data.due_exceed).toFixed(3)
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  formSubmit(e){
    e.preventDefault();
    $(".customer_outstandings_table tr").css("backgroud-color","");
    if(!this.state.executive.value){
      this.executiveSelect.current.focus();
      return;
    }
    this.getOutStandingData();
    
  }

  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="customer_outstanding_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Outstandings</div>
            <button className="refresh_button" type="button" onClick={this.getOutStandingData}>
              <i className="fas fa-sync-alt"></i>
            </button>
          </div> 
          <div className="search_container">
            <CgSearch/>
            <input className="customer_search_input" 
              placeholder="Search customer.."
              onChange={this.formChange}
            />
          </div>
          <form className="executive_due_period_form" onSubmit={this.formSubmit}>
            <div className="blocks">
              <div className="input_grid">
                <div>
                  <div className="input_label">Executive</div>
                  <Select 
                    options={this.state.executives}  
                    value ={this.state.executive}
                    className="executive" 
                    ref={this.executiveSelect}
                    onChange={e => this.executiveChange(e)}
                    required
                  />
                </div>
                </div>
                <div className="submit_button_container">
                  <button className="submit_button">Submit</button>
                </div>
            </div>
          </form>
          <div className="table_container">
            <table className="customer_outstandings_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th>Customer</th>
                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.showing_customers.length?"none":"table-row"}}>
                <td colSpan="2" align="center">No result!</td>
              </tr>
              {this.state.showing_customers && this.state.showing_customers.map((cust,index) => {
                const pdcTotal = (cust.bills || []).reduce((sum, bill) => {
                  const chequeAmount = parseFloat(bill.cheque_amount);
                  return sum + (chequeAmount > 0 ? chequeAmount : 0);
                }, 0);
                const finalBalanceTotal = (parseFloat(cust.pending_total) || 0) - pdcTotal;
                return (
                <tr key={index}  style={{backgroundColor:cust.pending_total>0 && !cust.no_due?"":""}}>
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top" style={{padding:"5px 0px"}}>
                    <div style={{fontWeight:"500",paddingLeft:"5px"}}>{cust.name}&nbsp;<span class="pdf_dwnld" dealer_id = {cust.id}><i class="fa fa-download" aria-hidden="true"></i></span></div>
                    <div
                      className="bills_table_container"
                      style={{display:cust.bills.length?"block":"none"}}
                    >
                      <table className="bills_table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Invoice No</th>
                            <th>Amount</th>
                            <th>Receivable</th>
                            {/* <th>Cheque Date</th> */}
                            <th>PDC Amount</th>
                            <th>Final Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cust.bills && cust.bills.map((bill,idx) => (
                          <tr key={idx} style={{backgroundColor:bill.cheque_date ? "#fff59d" : (bill.due_days!='+0' ?"#ffa8b3":"")}}>
                            <td>{new Date(bill.bill_date).toLocaleDateString('en-GB')}</td>
                            <td>{bill.bill_no}</td>
                            <td align="right" style={{textAlign:"right"}}>
                              <span>{parseFloat(bill.bill_amount).toFixed(3)}</span>
                              <span style={{marginLeft:"3px"}}>{this.context.currency}</span>
                            </td>
                            <td style={{border:"none",visibility:bill.receivable>0?"visible":"hidden",textAlign:"right"}} align="right">
                              <span >{parseFloat(bill.receivable).toFixed(3)}</span>
                              <span>({bill.due_days} Days)</span>
                            </td>
                            {/* <td>
                              {bill.cheque_date ? new Date(bill.cheque_date).toLocaleDateString('en-GB') : '-'}
                            </td> */}
                            <td align="right" style={{textAlign:"right"}}>
                              {bill.cheque_amount !== null && bill.cheque_amount !== undefined && parseFloat(bill.cheque_amount) > 0
                                ? (() => {
                                    let chequeDateStr = '';
                                    if (bill.cheque_date) {
                                      const d = new Date(bill.cheque_date);
                                      chequeDateStr = ` (${d.getDate().toString().padStart(2, '0')}-${(d.getMonth()+1).toString().padStart(2, '0')}-${d.getFullYear()})`;
                                    }
                                    return `${parseFloat(bill.cheque_amount).toFixed(3)}${chequeDateStr}`;
                                  })()
                                : '-'}
                            </td>
                            <td align="right" style={{textAlign:"right"}}>
                              {(() => {
                                const receivable = parseFloat(bill.exceed) || 0;
                                const chequeAmount = parseFloat(bill.cheque_amount);
                                const validChequeAmount = chequeAmount > 0 ? chequeAmount : 0;
                                return (receivable - validChequeAmount).toFixed(3);
                              })()}
                            </td>
                          </tr>
                          ))}
                          <tr className="finalTotal">
                            <td>Due Exceeded </td>
                            <td colSpan={2} style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                              {parseFloat(cust.exceed_due_total).toFixed(3)} <span style={{ marginLeft: "2px" }}>{this.context.currency}</span>
                            </td>
                            <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                              {parseFloat(cust.bill_amount_total).toFixed(3)} <span style={{ marginLeft: "2px" }}>{this.context.currency}</span>
                            </td>
                            <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                              {parseFloat(cust.pending_total).toFixed(3)} <span style={{ marginLeft: "2px" }}>{this.context.currency}</span>
                            </td>
                            {/* <td></td> */}
                            <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                              {pdcTotal.toFixed(3)} <span style={{ marginLeft: "2px" }}>{this.context.currency}</span>
                            </td>
                            <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                              <b>
                                {finalBalanceTotal.toFixed(3)} <span style={{ marginLeft: "2px" }}>{this.context.currency}</span>
                              </b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )})}
               <tr className="finalTotal">
                <td>

                </td>
                <td>
                  <span style={{ fontSize: "10px" }}>
                    <span >Due Exceeded: {parseFloat(this.state.due_exceed).toFixed(3)}  <span style={{ marginLeft: "1px" }}>{this.context.currency}</span></span>
                    <span style={{ marginLeft: "8px" }}>Outstanding: {parseFloat(this.state.outstanding).toFixed(3)}  <span style={{ marginLeft: "1px" }}>{this.context.currency}</span> </span>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default Outstanding;
Outstanding.contextType = MyContext;
